import React, {Component} from 'react';
import './fault.scss';
import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';

@connect(
    state => ({admin: state.admin}),
    {refresh_admin}
)

class Error404 extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {

        return (
            <div>

            </div>
        );
    }
}

export default Error404;


// WEBPACK FOOTER //
// ./src/pages/Fault/fault.js